import React from 'react'
import Main from 'layouts/main'
import { TabContent, TabPane } from 'reactstrap'
import { ApplicationState } from 'store'
import { useSelector } from 'react-redux'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import Search from './Tabs/Search'
import Register from './Tabs/Register'

const Campanhas = () => {
  const { activeTab } = useSelector<ApplicationState, CAMPANHA>(
    (state) => state.campanha
  )
  return (
    <Main>
      <TabContent activeTab={activeTab}>
        <TabPane tabId="search">
          <Search />
        </TabPane>
        <TabPane tabId="register">
          <Register />
        </TabPane>
      </TabContent>
    </Main>
  )
}

export default Campanhas
